import {
    CANDIDATE_ORIGINS_OPTIONS,
    CANDIDATE_ORIGIN_APPROVE_STATUS_OPTIONS,
    LOCAL_STORAGE_USER_LOGIN_INFO
} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import { showSuccessMessageSaveData } from "@pages/candidate/Common";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from "react-toastify";

import { checkExistsCommonFieldValues } from "@app/utils/CandidateUtils";

const CandidateOriginCard = ({
    isEditCandidateOrigin=false,
    candidateOrigin,
    onChange,
    allInputInfo,
    candidateId,
    mode = 'Edit' // Default to Edit mode for backward compatibility
}) => {
    const [isEdit, setIsEdit] = useState(isEditCandidateOrigin);
    const [origin, setOrigin] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});

    useEffect(() => {
        setOrigin(candidateOrigin);
        setIsEdit(isEditCandidateOrigin);
    }, [candidateOrigin, isEditCandidateOrigin]);

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, []);

    const onChangeInput = (event, field) => {
        if (field === 'origin') {
            candidateOrigin[field] = event
        } else {
            candidateOrigin[event.target.name] = event.target.value
        }
        setOrigin({...candidateOrigin})

        if (onChange) {
            onChange(candidateOrigin);
        }
    }
    
    const updateCandidateOrigin = () => {
        // Check xem trong số các trường sử dụng chung, giá trị đã đc nhập bởi user khác cho UV này chưa
        // Nếu có user khác nhập cho UV này giá trị rồi => báo lỗi, ko save thông tin vào DB.
        candidateOrigin.allOriginInfo = allInputInfo.allOriginInfo
        if (checkExistsCommonFieldValues(candidateOrigin, userLoginInfo.id)) {
            return;
        }
        // setIsLoading(true)
        CandidateService.updateCandidateOrigin({candidate_id: candidateId, candidate_origin: candidateOrigin}).then((res) => {
            showSuccessMessageSaveData(res.sts_code)
            setIsEdit(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            // setIsLoading(false)
        });
    };

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Nguồn person</h3>
                {mode === 'Edit' && (
                    <div className='card-tools'>
                        {isEdit &&
                            <>
                                <button type='button'
                                        className='btn btn-info mr-3'
                                        onClick={() => {
                                            updateCandidateOrigin();
                                        }}
                                >
                                    Save
                                </button>
                                <button type='button'
                                        className='btn btn-default mr-2'
                                        onClick={() => {
                                            setIsEdit(false);
                                        }}
                                >
                                    Cancel
                                </button>
                            </>
                        }
                        {!isEdit &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => {
                                        setIsEdit(true);
                                    }}
                            >
                                Edit
                            </button>
                        }
                    </div>
                )}
            </div>
            <div className='card-body'>
                <div className='input-group'>
                    <label className={'w-100'}><b>Nguồn UV</b></label>
                    <Select className='w-100'
                            name={'origin'}
                            options={CANDIDATE_ORIGINS_OPTIONS}
                            isMulti
                            isDisabled={!isEdit}
                            value={origin.origin ?? []}
                            onChange={value => onChangeInput(value, 'origin')}>
                    </Select>
                    <AllUserInputField arrInfo={allInputInfo.allOriginInfo}
                                       field='origin'/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Notes (Nguồn UV)</b></label>
                    <input type='text' className='form-control'
                           value={origin.origin_note ?? ''}
                           disabled={!isEdit}
                           name={'origin_note'}
                           onChange={event => onChangeInput(event)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Trạng thái duyệt</b></label>
                    <select className={`form-control`}
                            name={'approve_state'}
                            disabled={!isEdit}
                            value={origin.approve_state ?? ''}
                            onChange={event => onChangeInput(event)}>
                        <option value=''>&nbsp;</option>
                        {CANDIDATE_ORIGIN_APPROVE_STATUS_OPTIONS.map(item => {
                            return <option value={item.value}
                                           key={`origin_approve_state_${item.label}`}>
                                {item.label}</option>
                        })}
                    </select>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Notes (Duyệt)</b></label>
                    <textarea className='form-control'
                              value={origin.approve_note ?? ''}
                              disabled={!isEdit}
                              name={'approve_note'}
                              onChange={event => onChangeInput(event)}/>
                </div>
            </div>
        </div>
    );
};

export default CandidateOriginCard;


